import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { useQuestion } from "../context/QuestionContext";
import VaccineScheduleImg from "../img/vaccine-schedule.png";

/* ── Colores del mockup ── */
const TEAL = "#4abcc9";
const TEAL2 = "#257590";
const NAVY = "#0d1f2d";

/* ── URLs de imágenes (exactas del mockup) ── */
const DOCTOR_URL =
    "https://lh3.googleusercontent.com/aida-public/AB6AXuCLoUryLsCRMpibklKBnPkNnZ_Qsks5iCaHDK10GvG5fjshbOgcAc5mm1_T8dmzRhWZsWKxqEt-yfvymDUmGEc8iliMSutRXAaSQ_uz5dfaMaVYlawX6T2_uBCCs_E0E0G3ojtSjabUHQx6XOea0xuA2Nw47fdGVcahF4hdRB9nP--2dBE2VMw0-oNRhXR-rw_uJ4ctxCs6EcRx6XHAUrAVDxITyHTo-sTsTE7YT6hpBCtqM_xkHAFo2PGQTGOWNsNvnpBKRTZBXyfz";

const WHYCHOOSE_IMG =
    "https://lh3.googleusercontent.com/aida-public/AB6AXuDW8gJbhf0Z6kHZIoPBdjcPrWrBFLeIHiGb7S6rkCa5u9dsdA1wLmHhkNUh5tjfL8Raz1MbGqQklYUVlJrZx1E4lP_tGI3zfDq-ZoCopgDoWfrIi8Z3g6nmoSC4m6NbPsZEA5r0hnYwqsqd7oKrRljbnr82cofFEvL0cxFRHWo3FbUX15mxvuKvHcIdSBLewSMLFphq5_OTDI9mV3Qpm6_xpayp-cwU5CdOXhAnFtffEI8NeTv0LTBb5uhYA7c81ZnbGEFmToJJcTY";

const FEATURED_IMG =
    "https://lh3.googleusercontent.com/aida-public/AB6AXuBfc55MSMCPi3At3O-OT0aKuIU_I3NIHyBjPKuek-ItKzZA9i2OPvWe0sMBAIhXZttvpkOAnPoN4s2L7iM77oU3bzOolFSKDOz6wss089Dv4kuVbvpvytT3Ktb45JQqtauzVAuYI6zu4TQ8_gWiohBH5jj_ndDMfrBxJDytbuj5tQ212UVtjJgzRyzu8pqEZzFwtQThjU2Voe6045lx3xxLc4lsxh7iBTgjI0hXSFZAM2eF2mDzWBlEpyRm5_6ZK539g4up78nbW50";

const MEDS_IMG =
    "https://lh3.googleusercontent.com/aida-public/AB6AXuCTuGVc26ysJC8NWTmqDC6gWc6TOVejxoNmkNjSxEF8lRtWcr4wWKev4dTktvBYV1_nHUy0QneKpt8vSEM9wN_r-LPoZzJkvPMRyWa0oKQ_aF6ny30BMEBtnfUEEYWTNxd_DA-1N71KCX9-VfckWIwNRznuRLWviIC31IoeawKq8Qd7O7sv2fEV2t0U0f2WJ7PNJMWwmWzNVKPJ72JOcZ1Uu4DsChHzv6uQd6xVJMbBgYllNdAjxELQ5U2odf7q2mXC6qpGBzzKvVY";

const MENTAL_IMG =
    "https://lh3.googleusercontent.com/aida-public/AB6AXuBIQsOkDinDZ8gEvsteFvYDQgysBQY6rHv-A-tn27X-4DdmwkCaZbWolW1bub6rNdgqxiJhqKhFLGKlW7LCuRAl4LR7JhV-fznECCdGBAWM7CIq6AhEWk0klWx0p48JLFF8h5P9W0T1fBwG0jKTLTiFldN2X9MpIUhDtNb5VRbs1Cha-S9UlVEg_9WAtypqwajhbcUSABOluJZt2pkY5fmLCM3cGVOun4108O1AcdbbvQqIozq0Sggb_GHA1495RM_xcK6vp0mkdGg";

const NUTRI_IMG =
    "https://lh3.googleusercontent.com/aida-public/AB6AXuAnSwCwwHsk0uQsux5o6j9xtyYxL2KObSwCIzBTFkxcRaokimBxlnVHO8ToQ44k_B6Md1WRD7kmFMcLdrfF9L5QABm2OdlOCdPzGtlQfd0BqYui4mRoUxPzpOF9eX5sFbqwGxRPBUmdJfMS5kMFF4-M-cTARRnpvx39H66-e0XDyL4aCkrCUkhh4OSd4UT3SfYkDZUr9kAn_35pEeLia0viFNo1n6zG0v57Q2VzV9rAmDPyQ1ebuhrScA4fZyeEqaZ53HvwBkd3Zb0";

/* ── Helpers de estilos reutilizables ── */
const font = (size: string, weight: number, color: string, extra?: object) =>
    ({ fontFamily: "'Montserrat',sans-serif", fontSize: size, fontWeight: weight, color, ...extra } as React.CSSProperties);

export default function HomeContentPage() {
    const { questionForm, handleChangeQuestionForm } = useQuestion();
    const { pregunta } = questionForm;
    const navigate = useNavigate();
    const [validationMsg, setValidationMsg] = useState("");

    useEffect(() => {
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    }, []);

    const handleConsultar = () => {
        if (!pregunta.trim()) {
            setValidationMsg("Describe tu padecimiento o duda médica antes de continuar.");
            return;
        }
        setValidationMsg("");
        navigate("/perfilamiento");
    };

    return (
        <>
            {/* ═══════════════ HERO ═══════════════ */}
            <div className="hd-hero-section" style={{ background: "linear-gradient(to bottom,#f0f9fa,#ffffff)", padding: "60px 24px 48px", overflow: "hidden", position: "relative" }}>
                <div style={{ maxWidth: 1152, margin: "0 auto", textAlign: "center", position: "relative", zIndex: 10 }}>
                    <h1 style={{
                        fontFamily: "'Montserrat', sans-serif",
                        fontSize: "clamp(2.8rem,6vw,4.5rem)",
                        fontWeight: 900,
                        color: NAVY,
                        lineHeight: 1.1,
                        margin: "0 0 24px",
                        letterSpacing: "-1.5px",
                    }}>
                        Tu salud es prioridad:<br />
                        <span style={{ color: TEAL }}>Hey doctor está para ayudarte</span>
                    </h1>
                    <p style={{
                        fontFamily: "'Manrope', sans-serif",
                        fontSize: "1.125rem",
                        fontWeight: 400,
                        color: "#6b7280",
                        maxWidth: 672,
                        margin: "0 auto 48px",
                        lineHeight: 1.6,
                    }}>
                        Obtén respuestas médicas claras y rápidas desde la comodidad de tu hogar. Conéctate con especialistas
                        certificados al instante.
                    </p>

                    {/* Search container */}
                    <div style={{ position: "relative", maxWidth: 1100, margin: "0 auto 32px" }}>
                        {/* Free badge */}
                        <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: `linear-gradient(90deg,${TEAL},${TEAL2})`, color: "white", ...font("0.875rem", 700, "white"), padding: "8px 20px", borderRadius: 999, marginBottom: 14, boxShadow: "0 4px 14px rgba(74,188,201,0.35)" }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                            ¡Realiza todas tus preguntas médicas sin costo!
                        </div>

                        {/* Search box */}
                        <div style={{ background: "white", borderRadius: 20, boxShadow: "0 10px 40px rgba(74,188,201,0.18)", border: "1.5px solid rgba(74,188,201,0.2)", position: "relative", overflow: "hidden" }}>
                            {/* Doctor panel */}
                            <div className="hd-doctor-panel" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: 150, borderRadius: "75px 0 0 75px", overflow: "hidden", borderLeft: "5px solid white", boxShadow: "-4px 0 16px rgba(0,0,0,0.07)", zIndex: 0 }}>
                                <img src={DOCTOR_URL} alt="Doctora HeyDoctor" style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top center" }} />
                            </div>

                            {/* Content */}
                            <div className="hd-search-content" style={{ position: "relative", zIndex: 1, paddingRight: 130 }}>
                                <div style={{ display: "flex", alignItems: "flex-start", padding: "20px 20px 12px", gap: 12 }}>
                                    <div style={{ width: 40, height: 40, borderRadius: "50%", background: "#e8f7f9", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 4 }}>
                                        <svg fill="none" stroke={TEAL} viewBox="0 0 24 24" width="22" height="22">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-3-3v6m9-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <textarea
                                        name="pregunta"
                                        value={pregunta}
                                        onChange={handleChangeQuestionForm}
                                        placeholder="Describe tu padecimiento o duda médica... (ej. llevo 3 días con fiebre alta, dolor de cabeza y garganta inflamada)"
                                        style={{ flex: 1, border: "none", outline: "none", resize: "none", ...font("1rem", 400, NAVY), background: "transparent", lineHeight: 1.6, minHeight: 120, paddingTop: 6 }}
                                    />
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8, padding: "12px 20px", borderTop: "1px solid #f0f0f0" }}>
                                    {validationMsg && (
                                        <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#fff7ed", border: "1.5px solid #fed7aa", borderRadius: 10, padding: "8px 14px", width: "100%" }}>
                                            <span className="material-symbols-outlined" style={{ fontSize: 18, color: "#f97316", flexShrink: 0 }}>info</span>
                                            <span style={{ fontFamily: "'Manrope',sans-serif", fontSize: "0.82rem", color: "#c2410c", lineHeight: 1.4 }}>{validationMsg}</span>
                                        </div>
                                    )}
                                    <button
                                        onClick={handleConsultar}
                                        style={{ background: `linear-gradient(135deg,${TEAL},${TEAL2})`, color: "white", border: "none", borderRadius: 12, padding: "12px 28px", ...font("1rem", 700, "white"), cursor: "pointer", boxShadow: "0 4px 16px rgba(74,188,201,0.4)", transition: "all .2s" }}
                                        onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.transform = "translateY(-1px)"; }}
                                        onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.transform = "translateY(0)"; }}
                                    >
                                        Consultar Ahora
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

            {/* ═══════════════ HEALTH MEDIA ═══════════════ */}
            <section className="hd-media-section" style={{ background: "#0d1f2d", padding: "64px 0" }}>
                <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 24px" }}>
                    {/* Header */}
                    <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 32 }}>
                        <div style={{ height: 4, width: 40, background: TEAL, borderRadius: 2 }} />
                        <h2 style={{ ...font("1.25rem", 700, "white"), textTransform: "uppercase", letterSpacing: 2, margin: 0 }}>Health Media</h2>
                    </div>

                    {/* Grid: 3 columns */}
                    <div className="hd-media-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 24 }}>
                        {/* Featured Article (span 2) */}
                        <a className="hd-featured-link" href="https://es-us.noticias.yahoo.com/regreso-sarampi%C3%B3n-m%C3%A9xico-crisis-sanitaria-222055051.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAFc1dB8swEOKQD3lkwNYhmDzYzU1QG5ylosWP9ERAmVKbaSPVXbmEPuxEQtjfojSYcC5QGuqwBwnPkd5XyPqZInwGwy7m_zZJI8T0Tq4orsizO6M-GsW3BX2uuC2PvLBQWwDAlEHdZQembn9XyaSzNNjX0dnLNCchl6YkTrnMI8q" target="_blank" rel="noopener noreferrer" style={{ gridColumn: "span 2", display: "block", textDecoration: "none" }}>
                            <div style={{ position: "relative", overflow: "hidden", borderRadius: "1.25rem", height: 400, cursor: "pointer" }}
                                onMouseEnter={(e) => { (e.currentTarget.querySelector("img") as HTMLImageElement).style.transform = "scale(1.1)"; }}
                                onMouseLeave={(e) => { (e.currentTarget.querySelector("img") as HTMLImageElement).style.transform = "scale(1)"; }}
                            >
                                <img
                                    src={FEATURED_IMG}
                                    alt="Doctora en clínica sonriendo"
                                    style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", transition: "transform .7s" }}
                                />
                                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to right,rgba(13,31,45,0.90) 0%,rgba(13,31,45,0.4) 50%,transparent 100%)" }} />
                                <div style={{ position: "absolute", inset: 0, padding: "40px", display: "flex", flexDirection: "column", justifyContent: "flex-end", zIndex: 10 }}>
                                    <h3 style={{ ...font("clamp(1.5rem,2.5vw,2rem)", 700, "white"), lineHeight: 1.3, margin: "0 0 16px", maxWidth: 500 }}>
                                        El regreso del sarampión a México: ¿una crisis sanitaria?
                                    </h3>
                                    <p style={{ ...font("0.9rem", 500, "#d1d5db"), margin: "0 0 24px", maxWidth: 480, lineHeight: 1.6 }}>
                                        Entérate sobre los factores detrás de la baja cobertura de vacunación y las perspectivas del Dr. Rodrigo Romero Feregrino.
                                    </p>
                                    <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: TEAL, ...font("0.95rem", 700, TEAL) }}>
                                        Leer artículo completo
                                        <span className="material-icons-round" style={{ fontSize: "1.25rem" }}>arrow_forward</span>
                                    </div>
                                </div>
                            </div>
                        </a>

                        {/* Podcast / Youtube Card */}
                        <div className="hd-youtube-wrap" style={{ gridColumn: "span 1", borderRadius: "1.25rem", overflow: "hidden", height: 400, background: "rgba(255,255,255,0.05)", backdropFilter: "blur(10px)", border: "1px solid rgba(255,255,255,0.1)" }}>
                            <iframe
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/YnOQ27U8kiE"
                                title="¿Qué es el Sarampión? Dr. Rodrigo Romero Feregrino"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            ></iframe>
                        </div>

                        {/* Card VPH */}
                        <ArticleCard
                            img={MEDS_IMG}
                            tag="Reporte Médico"
                            icon="vaccines"
                            title="Retos en la vacunación contra VPH"
                            desc="Análisis sobre cómo aumentar la cobertura de la vacuna contra el Papiloma Humano en México."
                            href="https://espanol.medscape.com/verarticulo/5914561?form=fpf"
                        />
                        {/* Card AMV 2 */}
                        <ArticleCard
                            img={MENTAL_IMG}
                            tag="Entrevista"
                            icon="fact_check"
                            title="Mitos y realidades sobre el Sarampión"
                            desc="Lo que debes saber para protegerte, aclarado por el Dr. Romero."
                            href="https://animalpolitico.com/salud/mitos-casos-sarampion-mexico-vacunas"
                        />
                        {/* Card AMV 3 */}
                        <ArticleCard
                            img={VaccineScheduleImg}
                            tag="Guía Oficial"
                            icon="health_and_safety"
                            title="Conoce tu esquema de vacunación ideal"
                            desc="Portal oficial de la Asociación Mexicana de Vacunología (AMV)."
                            href="https://vacunacion.org/"
                        />
                    </div>
                </div>
            </section>

            {/* ═══════════════ STATS BAR ═══════════════ */}
            <section style={{ borderBottom: "1px solid #e2e8f0", background: "white", padding: "48px 0" }}>
                <div style={{ maxWidth: 1152, margin: "0 auto", padding: "0 24px" }}>
                    <div className="hd-stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 32 }}>
                        {[
                            { icon: "groups", num: "+10k", label: "Pacientes Atendidos" },
                            { icon: "verified_user", num: "50+", label: "Médicos Certificados" },
                            { icon: "schedule", num: "24/7", label: "Disponibilidad" },
                        ].map(({ icon, num, label }) => (
                            <div key={label} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, textAlign: "center" }}>
                                <div style={{ width: 48, height: 48, background: "rgba(74,188,201,0.1)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: TEAL, marginBottom: 8 }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: 28 }}>{icon}</span>
                                </div>
                                <h3 style={{ ...font("2.5rem", 800, NAVY), margin: 0 }}>{num}</h3>
                                <p style={{ ...font("1rem", 500, "#64748b"), margin: 0 }}>{label}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══════════════ 4 PASOS ═══════════════ */}
            <section style={{ background: "#f8fafc", padding: "80px 0" }}>
                <div style={{ maxWidth: 1152, margin: "0 auto", padding: "0 24px" }}>
                    <div style={{ textAlign: "center", marginBottom: 64 }}>
                        <span style={{ display: "inline-block", background: "rgba(74,188,201,0.12)", color: TEAL2, ...font("0.75rem", 800, TEAL2), letterSpacing: 1.5, textTransform: "uppercase", padding: "4px 14px", borderRadius: 9999, marginBottom: 12 }}>
                            Proceso Simple
                        </span>
                        <h2 style={{ ...font("clamp(1.8rem,3vw,2.5rem)", 800, NAVY), margin: "0 0 16px" }}>
                            Atención médica en <span style={{ color: TEAL }}>4 pasos</span>
                        </h2>
                        <p style={{ ...font("1.1rem", 400, "#475569"), maxWidth: 600, margin: "0 auto" }}>
                            Sigue estos sencillos pasos para recibir tu consulta médica profesional sin salir de casa.
                        </p>
                    </div>
                    <div className="hd-steps-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 24 }}>
                        {[
                            { num: "1", icon: "chat_bubble", title: "Haz una Pregunta", desc: "Describe tus síntomas detalladamente en nuestra plataforma segura." },
                            { num: "2", icon: "flash_on", title: "Recibe atención ágil", desc: "Un médico certificado analizará tu caso y te responderá rápidamente." },
                            { num: "3", icon: "medical_information", title: "Conoce tu tratamiento", desc: "Obtén tu diagnóstico detallado al momento." },
                            { num: "4", icon: "update", title: "Da seguimiento", desc: "Mantén el contacto para monitorear tu recuperación hasta estar al 100%." },
                        ].map(({ num, icon, title, desc }) => (
                            <div key={num} style={{ position: "relative", background: "white", borderRadius: 16, padding: 24, boxShadow: "0 1px 3px rgba(0,0,0,0.06)", border: "1px solid #f1f5f9", overflow: "hidden" }}>
                                <span style={{ position: "absolute", right: 16, top: 12, fontSize: "5rem", fontWeight: 900, color: "#f1f5f9", lineHeight: 1, fontFamily: "'Montserrat',sans-serif" }}>{num}</span>
                                <div style={{ width: 56, height: 56, background: "rgba(74,188,201,0.1)", borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", color: TEAL, marginBottom: 16 }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: 28 }}>{icon}</span>
                                </div>
                                <h3 style={{ ...font("1.1rem", 700, TEAL2), margin: "0 0 8px" }}>{title}</h3>
                                <p style={{ ...font("0.875rem", 400, "#64748b"), lineHeight: 1.6, margin: 0 }}>{desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ═══════════════ WHY CHOOSE US ═══════════════ */}
            <section style={{ background: "white", padding: "80px 0" }}>
                <div className="hd-why-inner" style={{ maxWidth: 1152, margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", gap: 80 }}>
                    {/* Image */}
                    <div className="hd-why-image" style={{ position: "relative", flex: 1 }}>
                        <div style={{ position: "relative", aspectRatio: "4/5", maxWidth: 400, overflow: "hidden", borderRadius: 16, background: "#f1f5f9", boxShadow: "0 20px 40px rgba(0,0,0,0.1)" }}>
                            <img src={WHYCHOOSE_IMG} alt="Doctor profesional" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            {/* Floating Badge */}
                            <div style={{ position: "absolute", bottom: 32, left: "50%", transform: "translateX(-50%)", display: "flex", alignItems: "center", gap: 12, background: "white", borderRadius: 12, padding: 16, boxShadow: "0 8px 24px rgba(0,0,0,0.12)", width: "85%" }}>
                                <div style={{ width: 40, height: 40, flexShrink: 0, background: "#fef9c3", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#eab308" }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: 22 }}>star</span>
                                </div>
                                <div>
                                    <p style={{ ...font("1.1rem", 800, NAVY), margin: 0 }}>4.9/5.0</p>
                                    <p style={{ ...font("0.75rem", 500, "#64748b"), margin: 0 }}>Satisfacción Pacientes</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    <div style={{ flex: 1 }}>
                        <span style={{ display: "inline-flex", alignItems: "center", background: "rgba(74,188,201,0.1)", color: TEAL, ...font("0.875rem", 700, TEAL), padding: "4px 14px", borderRadius: 9999, marginBottom: 24 }}>
                            Beneficios
                        </span>
                        <h2 style={{ ...font("clamp(1.8rem,3vw,2.5rem)", 800, NAVY), margin: "0 0 20px" }}>
                            ¿Por qué elegir HeyDoctor?
                        </h2>
                        <p style={{ ...font("1.1rem", 400, "#475569"), margin: "0 0 40px", lineHeight: 1.7 }}>
                            Combinamos la tecnología con la experiencia humana para brindarte un servicio de salud accesible, rápido y confiable.
                        </p>
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
                            {[
                                { icon: "volunteer_activism", title: "Asesoría gratuita", desc: "Consultas iniciales sin costo para evaluar tu caso." },
                                { icon: "chat", title: "Atención vía chat", desc: "Comunicación directa, sencilla y sin esperas." },
                                { icon: "check_circle", title: "Resolución efectiva", desc: "Diagnósticos precisos respaldados por especialistas." },
                                { icon: "history_toggle_off", title: "Acceso 24/7", desc: "Atención médica disponible en cualquier momento." },
                            ].map(({ icon, title, desc }) => (
                                <div key={title} style={{ display: "flex", gap: 16 }}>
                                    <div style={{ width: 40, height: 40, flexShrink: 0, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: TEAL }}>
                                        <span className="material-symbols-outlined">{icon}</span>
                                    </div>
                                    <div>
                                        <h4 style={{ ...font("0.95rem", 700, NAVY), margin: "0 0 4px" }}>{title}</h4>
                                        <p style={{ ...font("0.875rem", 400, "#64748b"), margin: 0 }}>{desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Concierge Médico */}
                        <div style={{ marginTop: 28, display: "flex", gap: 16, background: "linear-gradient(135deg,rgba(74,188,201,0.06),rgba(37,117,144,0.04))", border: "1px solid rgba(74,188,201,0.25)", borderLeft: `4px solid ${TEAL}`, borderRadius: 12, padding: "20px 24px", alignItems: "flex-start" }}>
                            <div style={{ width: 44, height: 44, flexShrink: 0, background: "rgba(74,188,201,0.12)", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", color: TEAL, marginTop: 2 }}>
                                <span className="material-symbols-outlined" style={{ fontSize: 24 }}>support_agent</span>
                            </div>
                            <div>
                                <h4 style={{ ...font("1rem", 800, NAVY), margin: "0 0 6px", display: "flex", alignItems: "center", gap: 8 }}>
                                    Concierge Médico
                                    <span style={{ background: TEAL, color: "white", ...font("0.6rem", 700, "white"), padding: "2px 8px", borderRadius: 999, letterSpacing: 0.5, textTransform: "uppercase" }}>Exclusivo</span>
                                </h4>
                                <p style={{ ...font("0.875rem", 400, "#475569"), margin: 0, lineHeight: 1.7 }}>
                                    Nuestro servicio de Concierge Médico te ofrece acceso directo y continuo con nuestros médicos, garantizando un acompañamiento personalizado para resolver cualquier duda médica, gestionar tus necesidades de salud de manera más eficiente y mantener un seguimiento puntual de los tratamientos indicados.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ═══════════════ CTA ═══════════════ */}
            <section style={{ background: "linear-gradient(135deg,#131d1f 0%,#1e293b 100%)", padding: "80px 24px", color: "white", textAlign: "center" }}>
                <div style={{ maxWidth: 896, margin: "0 auto" }}>
                    <h2 style={{ ...font("clamp(2rem,4vw,3rem)", 800, "white"), margin: "0 0 20px" }}>
                        ¿Listo para cuidar tu salud?
                    </h2>
                    <p style={{ ...font("1.1rem", 400, "#94a3b8"), maxWidth: 600, margin: "0 auto 40px", lineHeight: 1.7 }}>
                        Únete a miles de pacientes satisfechos hoy mismo. Tu salud no puede esperar, empieza con una consulta gratuita.
                    </p>
                    <div style={{ display: "flex", justifyContent: "center", gap: 16, flexWrap: "wrap" }}>
                        <Link to="/perfilamiento" style={{ textDecoration: "none" }}>
                            <button style={{ background: "white", color: NAVY, border: "none", padding: "14px 32px", borderRadius: 8, ...font("1rem", 700, NAVY), cursor: "pointer" }}>
                                Empezar ahora
                            </button>
                        </Link>
                        <Link to="/quienes-somos" style={{ textDecoration: "none" }}>
                            <button style={{ background: "transparent", color: "white", border: "1px solid rgba(255,255,255,0.3)", padding: "14px 32px", borderRadius: 8, ...font("1rem", 700, "white"), cursor: "pointer" }}>
                                Saber más
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}

/* ── Sub-componente para las Article Cards de Health Media ── */
function ArticleCard({ img, tag, icon, title, desc, href }: { img: string; tag: string; icon: string; title: string; desc: string; href: string }) {
    return (
        <a href={href} target="_blank" rel="noopener noreferrer" style={{ display: "block", textDecoration: "none" }}>
            <div style={{ position: "relative", overflow: "hidden", borderRadius: "1.25rem", height: 320, cursor: "pointer" }}
                onMouseEnter={(e) => { (e.currentTarget.querySelector("img") as HTMLImageElement).style.transform = "scale(1.1)"; }}
                onMouseLeave={(e) => { (e.currentTarget.querySelector("img") as HTMLImageElement).style.transform = "scale(1)"; }}
            >
                <img src={img} alt={title} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", transition: "transform .7s" }} />
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top,rgba(13,31,45,0.95) 0%,rgba(13,31,45,0.6) 40%,rgba(13,31,45,0) 100%)" }} />
                <div style={{ position: "absolute", inset: 0, padding: 24, display: "flex", flexDirection: "column", justifyContent: "flex-end", zIndex: 10 }}>
                    <div style={{ marginBottom: "auto" }}>
                        <span style={{ display: "inline-block", padding: "4px 12px", borderRadius: 9999, fontSize: "0.75rem", fontWeight: 600, color: "white", marginBottom: 16, background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.1)" }}>{tag}</span>
                    </div>
                    <span className="material-icons-outlined" style={{ color: "white", fontSize: "2.5rem", marginBottom: 12 }}>{icon}</span>
                    <h3 style={{ fontFamily: "'Montserrat',sans-serif", fontSize: "1.25rem", fontWeight: 700, color: "white", lineHeight: 1.3, margin: "0 0 8px" }}>{title}</h3>
                    <p style={{ fontFamily: "'Montserrat',sans-serif", fontSize: "0.75rem", color: "#d1d5db", margin: "0 0 16px", lineHeight: 1.6 }}>{desc}</p>
                    <div style={{ display: "flex", alignItems: "center", color: "#4abcc9", fontSize: "0.875rem", fontWeight: 700, gap: 4 }}>
                        Leer más <span className="material-icons-round" style={{ fontSize: "1rem" }}>arrow_forward</span>
                    </div>
                </div>
            </div>
        </a>
    );
}
